import React from "react";
import IMAGES from "../../../../constant/images";

export default function Index() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-6">
      {/* Image */}
      <div className="mb-6 flex items-center justify-center">
        <img
          src={IMAGES.empty_stats}
          alt="Empty Analytics"
          className="w-50 opacity-80"
        />
      </div>

    </div>
  );
}
